import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDumbbell = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14 22.25H26",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 17.75H26",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.75 32.75C11.1533 32.75 10.581 32.5129 10.159 32.091C9.73705 31.669 9.5 31.0967 9.5 30.5V9.5C9.5 8.90326 9.73705 8.33097 10.159 7.90901C10.581 7.48705 11.1533 7.25 11.75 7.25V7.25C12.3467 7.25 12.919 7.48705 13.341 7.90901C13.7629 8.33097 14 8.90326 14 9.5V30.5C14 31.0967 13.7629 31.669 13.341 32.091C12.919 32.5129 12.3467 32.75 11.75 32.75Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 13.25V26.75",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 20H3.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 30.5V9.5C26 8.90326 26.2371 8.33097 26.659 7.90901C27.081 7.48705 27.6533 7.25 28.25 7.25C28.8467 7.25 29.419 7.48705 29.841 7.90901C30.2629 8.33097 30.5 8.90326 30.5 9.5V30.5C30.5 31.0967 30.2629 31.669 29.841 32.091C29.419 32.5129 28.8467 32.75 28.25 32.75C27.6533 32.75 27.081 32.5129 26.659 32.091C26.2371 31.669 26 31.0967 26 30.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.25 26.75V13.25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5 20H34.25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgDumbbell);
export default ForwardRef;
